<script setup>
import { utils } from '@shop/frontend/web/js/utils';
import { ref } from 'vue';
import { translator } from '@shop/frontend/web/js/services/TranslatorService';

translator.getLanguages();

const isCookieNotificationShow = ref(!utils.getCookie('isCookieAccepted'));

function closeCookieModal() {
  utils.setCookie('isCookieAccepted', 'true', { expires: 30 * 24 * 60 * 60, path: '/' });
  isCookieNotificationShow.value = false;
}
</script>

<template>
  <transition name="slide-out-bottom">
    <div v-if="isCookieNotificationShow" class="cookie-dialog">
      <div class="cookie-dialog__wrapper">
        <div class="cookie-dialog__main-content">
          <p class="cookie-dialog__text">
            Я соглашаюсь с тем, что владелец сайта использует файлы для cookie для повышения удобства работы на сайте и сервис Яндекс.Метрика. Оставаясь на сайте, я соглашаюсь с политикой их применения
          </p>
          <button class="cookie-dialog__btn btn" @click="closeCookieModal">
            Принять
          </button>
        </div>
        <button class="cookie-dialog__close" @click="isCookieNotificationShow = false">
          <svg class="icon cookie-dialog__close-icon">
            <use xlink:href="#close" />
          </svg>
        </button>
      </div>
    </div>
  </transition>
</template>

<style lang="scss">
@import "@shop/../frontend/web/src/styles/utils/variables.scss";

.cookie-dialog {
  position: fixed;
  display: flex;
  justify-content: center;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 9999;
  background-color: $skeleton;
  width: 100%;

  &__wrapper {
    position: relative;
    display: flex;
    align-items: center;
    gap: 16px;
    padding: 16px;
    max-width: 1110px;
    width: 98%;
  }

  &__main-content {
    max-width: 746px;
    width: 90%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 0 auto;
  }

  &__cookie-icon {
    width: 65px;
    height: 46px;
  }

  &__btn {
    padding: 11px 28px;
    font-size: 14px;
    font-weight: 700;
    background-color: $primary;
    border-radius: 8px;
    line-height: 100%;
  }

  &__close {
    position: absolute;
    top: 2px;
    right: 0px;
    padding: 4px;
    color: $cookie-primary-color;
    cursor: pointer;
    background: none;
    border: 0;
  }

  &__close-icon {
    width: 16px;
    height: 16px;
    color: $black;
  }

  &__text {
    margin: 0;
    max-width: 500px;
    font-weight: 400;
    font-size: 14px;
    line-height: 100%;
  }

  @media (max-width: $screen-xs) {
    bottom: 0;

    &__wrapper {
      padding: 35px 16px;
      flex-direction: column;
    }

    &__text {
      max-width: none;
      margin-bottom: 15px;
      font-size: 12px;
    }

    &__main-content {
      flex-direction: column;
      width: 100%;
      padding: 0;
    }

    &__btn {
      width: 100%;
    }
  }
}

.left-cookie {
  fill: $cookie-left-color;
}

.right-cookie {
  fill: $cookie-right-color;
}
</style>
